module.exports = __webpack_public_path__ + "static/media/2.dd1bd97c.jpg";